import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthenticatedUserService } from '../authenticated-user/authenticated-user.service';
import { SideMenuItems } from 'src/app/shared/models/side-menu-items/side-menu-items';

@Injectable({
  providedIn: 'root',
})
/**
 * Service that controls side menu appearance
 */
export class SidenavService {
  public sideNavToggleSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  sideMenuItems: SideMenuItems = new SideMenuItems();

  /**
   * @constructor
   */
  constructor(private authenticatedUserService: AuthenticatedUserService) {}

  /**
   * Toggles sidenav
   * @return {any}
   */
  public toggle() {
    return this.sideNavToggleSubject.next(null);
  }

  /**
   * Gets menu items set
   * @return {string[]}
   */
  getMenuItems(): string[][] {
    if (this.authenticatedUserService.isRegionalAdmin()) {
      return this.sideMenuItems.regionalFlatNavItems;
    } else if (this.authenticatedUserService.isGlobalAdmin()) {
      return this.sideMenuItems.globalFlatNavItems;
    } else {
      return this.sideMenuItems.viewOnlyFlatNavItems;
    }
  }
}
